<template>
  <div v-if="showBanner" class="status-banner" :class="{'status-banner--bypassed': hasBlock.bypassed}" :style="bannerStyle">
    <div class="status-banner__content">
      <i :class="lockIcon" class="status-banner__icon"></i>
      <span class="status-banner__message">{{ statusMessage }}</span>
      <span v-if="showDateRange && !hasBlock.bypassed" class="status-banner__date">
        ({{ formatDate(hasBlock.from) }} - {{ formatDate(hasBlock.till) }})
      </span>
    </div>
    <button v-if="isAdmin" class="status-banner__bypass" @click="toggleBypass">
      <i :class="bypassIcon"></i>
      <span>{{ bypassText }}</span>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'StatusBanner',
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      hasBlock: s => s.operationStatus.hasBlock
    }),
    showBanner() {
      return this.hasBlock && this.hasBlock.isActive
    },
    bannerStyle() {
      if (this.hasBlock?.bypassed) {
        return { backgroundColor: '#28a745' }
      }
      if (!this.hasBlock?.colour) return { backgroundColor: '#DA4040' }
      return { backgroundColor: this.hasBlock.colour }
    },
    showDateRange() {
      return this.hasBlock?.from && this.hasBlock?.till
    },
    lockIcon() {
      return this.hasBlock?.bypassed ? 'ri-lock-unlock-fill' : 'ri-lock-fill'
    },
    statusMessage() {
      if (this.hasBlock?.bypassed) {
        return 'Orders temporarily enabled - Status: ' + this.hasBlock.message
      }
      return this.hasBlock?.message
    },
    bypassIcon() {
      return this.hasBlock?.bypassed ? 'ri-lock-fill' : 'ri-lock-unlock-fill'
    },
    bypassText() {
      return this.hasBlock?.bypassed ? 'Disable Orders' : 'Enable Orders'
    }
  },
  methods: {
    ...mapActions({
      byPassBlock: 'operationStatus/byPassBlock',
      byPassEnd: 'operationStatus/byPassEnd'
    }),
    formatDate(date) {
      return moment(date).utc().format('MMM D')
    },
    async toggleBypass() {
      if (this.hasBlock?.bypassed) {
        await this.byPassEnd()
      } else {
        await this.byPassBlock()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
